import type { ReactNode } from 'react';

interface EmptyStateProps {
  title: string;
  hint?: string;
  action?: ReactNode;
}

export function EmptyState({ title, hint, action }: EmptyStateProps) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 border border-dashed border-[var(--border)] py-10 text-center">
      <p className="text-[13px] text-[var(--text-dim)]">{title}</p>
      {hint && <p className="text-[11.5px] text-[var(--text-faint)]">{hint}</p>}
      {action}
    </div>
  );
}
